import React from 'react';
import { modelClass } from '/imports/api/rarities';
import { ModelFormPage } from '/imports/ui/ModelFormPage';

export const RarityPage = () => (
  <ModelFormPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    formSpec={() => [[{ field: 'name', label: 'Name' }], [{ field: 'bbprice', label: 'Bulk Buy Price' }], [{ field: 'bsprice', label: 'Bulk Sell Price' }], [{ field: 'bbfprice', label: 'Bulk Buy Foil Price' }], [{ field: 'bsfprice', label: 'Bulk Sell Foil Price' }]]}
  />
);
